/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Dashboard_WelcomeInputs */

const en_dashboard_welcome = /** @type {(inputs: Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hey ${i?.name}, ready to apply?`)
};

const de_dashboard_welcome = /** @type {(inputs: Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Willkommen zurück, ${i?.name}`)
};

const fr_dashboard_welcome = /** @type {(inputs: Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bienvenue, ${i?.name}`)
};

const es_dashboard_welcome = /** @type {(inputs: Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bienvenido de nuevo, ${i?.name}`)
};

const it_dashboard_welcome = /** @type {(inputs: Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ben tornato, ${i?.name}`)
};

const nl_dashboard_welcome = /** @type {(inputs: Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Welkom terug, ${i?.name}`)
};

const pl_dashboard_welcome = /** @type {(inputs: Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Witaj ponownie, ${i?.name}`)
};

const fi_dashboard_welcome = /** @type {(inputs: Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tervetuloa takaisin, ${i?.name}`)
};

const da_dashboard_welcome = /** @type {(inputs: Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Velkommen tilbage, ${i?.name}`)
};

const sv_dashboard_welcome = /** @type {(inputs: Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Välkommen tillbaka, ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Hey {name}, ready to apply?" |
*
* @param {Dashboard_WelcomeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_welcome = /** @type {((inputs: Dashboard_WelcomeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_WelcomeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_welcome(inputs)
	if (locale === "fr") return fr_dashboard_welcome(inputs)
	if (locale === "es") return es_dashboard_welcome(inputs)
	if (locale === "it") return it_dashboard_welcome(inputs)
	if (locale === "nl") return nl_dashboard_welcome(inputs)
	if (locale === "pl") return pl_dashboard_welcome(inputs)
	if (locale === "fi") return fi_dashboard_welcome(inputs)
	if (locale === "da") return da_dashboard_welcome(inputs)
	if (locale === "sv") return sv_dashboard_welcome(inputs)
	return en_dashboard_welcome(inputs)
});